export type LocationInstallationImage = {
  src: string;
  alt: string;
  title: string;
};

const BASE = "/static/services/autoconsumo-domestico";

/**
 * SEO alt/title variants applied per image index. `{city}` is replaced with the
 * province name so every location page keeps "placas solares en <ciudad>" and
 * close variants on each photo.
 */
const ALT_VARIANTS = [
  "Placas solares en {city}",
  "Instalación de placas solares en {city}",
  "Placas solares en {city} instaladas por Geesol",
  "Placas solares para casas en {city}",
  "Autoconsumo con placas solares en {city}",
  "Placas solares en viviendas de {city}",
];

/**
 * Residential ("particulares") installation photos reused from the
 * placas-solares-para-casas gallery. Physical filenames are kept as-is; the SEO
 * signal for each location lives in the alt/title variants above.
 */
const DEFAULT_SRCS = [
  `${BASE}/dos-hermanas-sevilla-01.webp`,
  `${BASE}/alcala-de-guadaira-sevilla.webp`,
  `${BASE}/carmona-sevilla.webp`,
  `${BASE}/gelves-sevilla.webp`,
  `${BASE}/bormujos-sevilla.webp`,
  `${BASE}/coria-del-rio-sevilla.webp`,
];

const SRCS_BY_CITY: Record<string, string[]> = {
  Sevilla: DEFAULT_SRCS,
  "Cádiz": [
    `${BASE}/sotogrande-cadiz.webp`,
    `${BASE}/jerez-de-la-frontera-cadiz-01.webp`,
    `${BASE}/jerez-de-la-frontera-cadiz-02.webp`,
    `${BASE}/conil-de-la-frontera-cadiz.webp`,
    `${BASE}/el-puerto-de-santa-maria-cadiz-01.webp`,
    `${BASE}/el-puerto-de-santa-maria-cadiz-02.webp`,
  ],
};

export const getLocationInstallationsGallery = (city: string): LocationInstallationImage[] => {
  const srcs = SRCS_BY_CITY[city] ?? DEFAULT_SRCS;

  return srcs.map((src, index) => {
    const label = (ALT_VARIANTS[index] ?? ALT_VARIANTS[0]).replace("{city}", city);
    return { src, alt: label, title: label };
  });
};
